import React, { useState, useEffect }  from 'react';

import { useNavigate} from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
import {db} from '../../firebase'

function Slider2 () {
   const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
      const [showPerPage, setShowPerPage] = useState(9);
      const [pagination, setPagination] =useState({
          start: 0,
          end: showPerPage,
      });
  
      const onPaginationChange = (start,  end) =>{
          setPagination({start: start, end: end});
      };
      const [searchTerm, setsearchTerm] = useState("");
      const [cafeslide, setCafeslide] = useState([])
      const navigate = useNavigate()
  
      const cafeslideCollectionRef = collection(db, "cafeslide");
      useEffect(() => {
  
          const getCafeslide = async () => {
              const data = await getDocs(cafeslideCollectionRef);
              setCafeslide(data.docs.map((doc) => ({...doc.data(), id: doc.id })))
          }
  
          getCafeslide()
      }, [])
  return (
    <div>

{cafeslide.filter((val)=>{
      if (setsearchTerm === ""){
        return val;
      } {
        return val;
      }
    }).slice(pagination.start, pagination.end).map((psluxuryhotel) => { return (
       
       
                       
                            <div className="card-body">
                                   
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
      
    
    
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={psluxuryhotel.slider1} className="d-block w-100" alt="ps-luxury-hotel"/>
        </div>
        <div className="carousel-item">
          <img src={psluxuryhotel.slider2} className="d-block w-100" alt="ps-luxury-hotel"/>
        </div>
       

       
      </div>
     
      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  
                                
                               
                              
                                {/* <h5 style={{color: "Darkblue"}}className="card-text"> ₹{website.saleprice} </h5>
                                <p style={{color: "Gray"}}className="card-text mb-2"> M.R.P.: <del> ₹{website.delete}</del> </p> */}
                               

                               
                    
                              
                            </div>
                           
                                )})} 
                            
                            {/* <PaginationOld showPerPage={showPerPage} 
                onPaginationChange={onPaginationChange}
                total={cafeslide.length}
                /> */}
      
    </div>
  )
}

export default Slider2
